import { toast as sonnerToast } from 'sonner';
import { MessageOptions, MessageVariant } from './message.types';
import { StyledMessage } from './message.styled';
import { Icons } from 'assets';
import { InlineSpinner } from '../../../loaders/inline-spinner/inline-spinner';
import { SVG } from '../../../svg/svg';
import { Text } from '../../text';

export interface MessageFn {
  (options: MessageOptions): NonNullable<MessageOptions['id']>;
  dismiss: (id: NonNullable<MessageOptions['id']>) => void;
}

export const message: MessageFn = (options: MessageOptions) => {
  const { type = 'info', text = '', ...restProps } = options;

  const icons = {
    info: <SVG src={Icons.InformationCircleFilled} />,
    success: <SVG src={Icons.CheckCircleFilled} />,
    warning: <SVG src={Icons.ExclamationCircleFilled} />,
    error: <SVG src={Icons.CrossCircleFilled} />,
  };

  /** TODO: Добавить остальные базовые тексты. Наверняка найдутся,
   * но сейчас постоянно копировать "Упс..."" надоело :( */
  const baseText: Record<MessageVariant, string> = {
    info: 'Информация',
    success: 'Успешно',
    warning: 'Внимание',
    error: 'Упс...Что-то пошло не так, повторите попытку',
    pending: 'Пожалуйста, подождите...',
  };

  return sonnerToast.custom(
    () => (
      <StyledMessage $type={type}>
        {type === 'pending' ? (
          <InlineSpinner color="primary.400" />
        ) : (
          icons[type]
        )}
        <Text>{text || baseText[type]}</Text>
      </StyledMessage>
    ),
    {
      ...restProps,
      toasterId: restProps.toasterId ?? 'message-toaster',
      duration: restProps.duration ?? 5000,
    }
  );
};

message.dismiss = (id) => sonnerToast.dismiss(id);
